import { useEffect } from 'react';

const BASE_TITLE = 'Ratekauer Feuerwehr-Dart-Cup';

/**
 * Sets the document title for a route and restores the base title on unmount,
 * so each page is distinguishable in the browser tab and history.
 */
export function usePageTitle(title?: string): void {
  useEffect(() => {
    document.title = title === undefined ? BASE_TITLE : `${title} · ${BASE_TITLE}`;
    return () => {
      document.title = BASE_TITLE;
    };
  }, [title]);
}
